// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"1199572f","213":"97ea10d7","239":"198aa76a","455":"2f3e523d","976":"8b0d010e"}[chunkId] + ".chunk.js";
};